export const parseResourceToModel = (resource) => ({
    ...resource,
  });
  
  export const parseResourceToObject = (data) => ({
    ...data,
  });
  